// extracted by mini-css-extract-plugin
module.exports = {"note":"styles__note--GlF0d","grid":"styles__grid--3chp3"};